var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Icon from "./Icon";
import * as React from "react";
import { styled } from "../theme/ThemeHelpers";
var LabelContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    vertical-align: middle;\n    text-align: center;\n    display: inline-block;\n"], ["\n    vertical-align: middle;\n    text-align: center;\n    display: inline-block;\n"])));
var LabelIconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    vertical-align: middle;\n    text-align: center;\n    display: inline-block;\n    margin-right:5px;\n"], ["\n    vertical-align: middle;\n    text-align: center;\n    display: inline-block;\n    margin-right:5px;\n"])));
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n"], ["\n    display: inline-block;\n"])));
var Label = React.memo(function (props) {
    var icon = props.icon, content = props.content;
    return (React.createElement(Container, null,
        icon &&
            React.createElement(LabelIconContainer, null,
                React.createElement(Icon, { inheritColor: true, name: icon })),
        content &&
            React.createElement(LabelContainer, null, props.bold ?
                React.createElement("b", null, content) :
                content)));
});
export default Label;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Label.js.map